import moment from 'moment'

const SET_UPDATE_TIME = 'SET_UPDATE_TIME'
const initState = () => {
  return {
    updateTime: moment().format('YYYY-MM-DD') 
  }
}

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    [SET_UPDATE_TIME](state, payload) {
      state.updateTime = payload
    }
  },
  actions: {
    setUpdateTime({ commit }, payload) {
      commit(SET_UPDATE_TIME, payload)
    }
  }
}